import React from 'react';
import { Box } from '@mui/material';
import PageContainer from 'components/PageContainer/PageContainer';
import Typography from '@mui/material/Typography';
import { anchoMaxForms, datosTeatro, urlLeyDatosPersonales, urlMercadoPago } from '../../utils/constants';
import { PoliticaDatos } from '../../utils/models/interfaces';

interface PoliticasProps {
  titulo: string;
  textos: PoliticaDatos[];
}

const PoliticasDinamico = ({ titulo, textos }: PoliticasProps) => {
  return (
    <PageContainer marginBottom={true}>
      <Box width={800} textAlign="left" overflow="unset" maxWidth={anchoMaxForms}>
        <Typography variant="h4" fontWeight={600} marginBottom={1}>
          {titulo}
        </Typography>
        <Typography variant="body2" marginBottom={2}>
          <b>Última modificación:</b> 02/09/2024
        </Typography>
        {textos.map(({ titulo, subtitulo, texto }: PoliticaDatos, i) => (
          <React.Fragment key={`${titulo}-${i}`}>
            {titulo && (
              <Typography variant="h6" my={2}>
                {titulo}
              </Typography>
            )}
            {subtitulo && (
              <Typography variant="h6" fontSize="1rem" my={2}>
                {subtitulo}
              </Typography>
            )}
            {texto.includes(urlLeyDatosPersonales) ? (
              <>
                {texto.split(urlLeyDatosPersonales)[0]}
                <a href={urlLeyDatosPersonales} target="_blank" rel="noopener noreferrer">
                  Ley N° 18.331 sobre Protección de Datos Personales
                </a>
                {texto.split(urlLeyDatosPersonales)[1]}
              </>
            ) : texto.includes(urlMercadoPago) ? (
              <>
                {texto.split(urlMercadoPago)[0]}
                <a href={urlMercadoPago} target="_blank" rel="noopener noreferrer">
                  Términos y Políticas de Mercado Pago
                </a>
                {texto.split(urlMercadoPago)[1]}
              </>
            ) : texto.includes(datosTeatro.email) ? (
              <>
                {texto.split(datosTeatro.email)[0]}
                <a href={`mailto:${datosTeatro.email}`} target="_blank" rel="noopener noreferrer">
                  {datosTeatro.email}
                </a>
                {texto.split(datosTeatro.email)[1]}
              </>
            ) : (
              texto
            )}
          </React.Fragment>
        ))}
      </Box>
    </PageContainer>
  );
};

export default PoliticasDinamico;
